import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import plusIcon from '../../asset/img/common/addbutton_plus_primary_icon.svg';
import Typography from '../../components/common/Typography';
import Chips from '../../components/common/Chips';

const AddButtonStyled = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid var(--GrayScale-400);
  background: var(--GrayScale-0);
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  cursor: pointer;

  flex: 1;
`;

const AddButton = ({ title, status = '', path, onClick }) => {
  const navigate = useNavigate();

  const statusProps = {
    color: status == '1' ? 'success' : 'error',
    label: status == '1' ? '제출' : '미제출',
  };

  return (
    <AddButtonStyled>
      <Chips color={statusProps.color}>{statusProps.label}</Chips>
      <ButtonWrapper onClick={onClick}>
        <Typography style={{ whiteSpace: 'pre-wrap' }} variant="body2Medium" color="GrayScale-900">
          {title}
        </Typography>
        <img src={plusIcon} alt={`${title} 증빙서류 추가`} />
      </ButtonWrapper>
    </AddButtonStyled>
  );
};

export default AddButton;

export const EvidenceTypeSelectedButton = ({ title, onClick }) => {
  return (
    <AddButtonStyled
      style={{ background: 'var(--GrayScale-100)', border: 'none' }}
      onClick={onClick}>
      <ButtonWrapper>
        <Typography style={{ whiteSpace: 'pre-wrap' }} variant="body2Medium" color="GrayScale-900">
          {title}
        </Typography>
        <img src={plusIcon} alt={`${title} 증빙서류 추가`} />
      </ButtonWrapper>
    </AddButtonStyled>
  );
};
